import * as React from 'react';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { columnName, tableName } from 'app/area/case/case-data-model';

type WithHideUndoEgressOwnProps = {
  rowEntity?: any;
  entryLogAllRows?: any[];
};

const egressTimeField =
  columnName[tableName.involvedPersonEntryLog].egressTime;

const hasEgressTime = (row: any) => !!get(row, `${egressTimeField}[0].value`);

const isLastRow = (rowEntity: any, rows: any[] = []) => {
  const lastRow = rows[rows.length - 1];

  return !!rowEntity && !!lastRow && isEqual(lastRow.id, rowEntity.id);
};

/**
 * Only the last entry log row can be un-egressed. "Undo Egress" is hidden on every other row,
 * so while the last row is still open (shows "Egress") the rows before it cannot be undone
 * until that last row is deleted.
 */
export const withHideUndoEgress = <
  P extends WithHideUndoEgressOwnProps
>(
  WrappedComponent: React.ComponentClass<P> | React.FC<P>
) => {
  return class extends React.PureComponent<P> {
    public render() {
      const { entryLogAllRows, ...rest } = this.props as any;
      const { rowEntity } = rest;

      const injectedProps = {
        ...rest,
        hideUndoEgress: hasEgressTime(rowEntity) && !isLastRow(rowEntity, entryLogAllRows)
      } as P;

      return <WrappedComponent {...injectedProps} />;
    }
  };
};
